import { EventPaginationParams, FetchEventRepository } from '@/module/event/data/repository/fetch_event_repository';
import { Event, en } from "../model/event";

export interface FetchLastEventForOwnerUseCase {
  (ownerType: string, ownerID: number, eventType?: string): Promise<Event | undefined>
}

const fetchLastEventForOwnerUseCase = (repository: FetchEventRepository): FetchLastEventForOwnerUseCase => async (ownerType: string, ownerID: number, eventType?: string) => {
  const payload: EventPaginationParams = {
    descending: "true",
    eventType: eventType ?? "",
    itemsPerPage: 1,
    ownerID,
    ownerType,
    page: 1,
    sort: en.created_date.toString()
  }

  const result = await repository(payload);

  return result.items.at(0)
}

export default fetchLastEventForOwnerUseCase;
